// Web shim for react-native-webview using iframe
import React from 'react';
import { View } from 'react-native';

function WebView({ source, style, onNavigationStateChange, onMessage, ...props }) {
  const uri = source?.uri || '';
  const html = source?.html || '';

  const handleLoad = (e) => {
    if (onNavigationStateChange) {
      onNavigationStateChange({
        url: e.target.contentWindow?.location?.href || uri,
        loading: false,
        title: '',
        canGoBack: false,
        canGoForward: false,
      });
    }
  };

  if (html) {
    return (
      <View style={[{ flex: 1 }, style]}>
        <iframe
          srcDoc={html}
          style={{ width: '100%', height: '100%', border: 'none' }}
          onLoad={handleLoad}
          title="webview"
        />
      </View>
    );
  }

  return (
    <View style={[{ flex: 1 }, style]}>
      <iframe
        src={uri}
        style={{ width: '100%', height: '100%', border: 'none' }}
        onLoad={handleLoad}
        title="webview"
      />
    </View>
  );
}

export { WebView };
export default WebView;
